import type {
  SYSAction,
  SYSTableDefIds,
} from "../../../../../../../../_ovlclient/src"
import { html } from "../../../../../../../../_ovlclient/src"
import type {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormChanged_Type,
  HookTableDialogGetTitleRender_ReturnType,
  HookTableDialogGetTitleRender_Type,
  HookFormInit_ReturnType,
  HookFormInit_Type,
  HookFormValidate_Type,
  HookTableBeforeSave_ReturnType,
  HookTableBeforeSave_Type,
  HookTableRowFnCan_Type,
  HookTableSetColumnVisibility_Type,
} from "../../../../../../../../_ovlclient/src/global/hooks"
import { EditLocked } from "../../../../screens/qutoffering/offering/helpers"
import { Costs, Material, Transport } from "./tabledefs"

import {
  FieldCurrentVal,
  FieldSetState,
  FieldSetVal,
  FieldVal,
} from "../../../../../../../../_ovlclient/src/library/forms/fieldapi"

import { N, T } from "../../../../../../../../_ovlclient/src/textapi"
import { FeatureInfo } from "../../../../../../../../_ovlclient/src/global/globalapi"
import {
  SYSTableDef,
  TableFormEditRow,
} from "../../../../../../../../_ovlclient/src/library/table/tableapi"

// const HookTableInit: SYSAction<HookTableInit_Type> = (value, { global }) => {
//   if (value.isInitialised) { return }
//   if (value.tableDef.id === "QUTOfferingCosts" && value.context === "after") {
//     value.tableDef.columns.Quantity.ui.visibility =
//       global.getState().app.features.QUTOffering.offerMainType === "CUT"
//         ? "None"
//         : "Table"
//   }
// }

const HookTableSetColumnVisibility: SYSAction<
  HookTableSetColumnVisibility_Type<Costs>
> = (value, { global }) => {
  if (value.def.id === "QUTOfferingCosts") {
    value.columnsVisibilityToSet.Quantity =
      global.getState().app.features.QUTOffering.offerMainType === "CUT"
        ? "None"
        : "Table_Edit_View"
  }
}

const HookTableBeforeSave: SYSAction<
  HookTableBeforeSave_Type,
  HookTableBeforeSave_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  if (value.tableDef.def.id === "QUTOfferingMaterial") {
    let itemCode = value.changedFields["ItemCode"]
    if (itemCode) {
      let itemName =
        state.app.features.QUTOffering.lookups.U_ItemCode.data[
          itemCode.toString()
        ]["ItemName"]
      let skl = value.tableDef.data.data[value.key]["Skl"]
      // update sourcelist with new itemdata
      let changed = false
      value.tableDef.def.uiState.dataFilteredAndSorted.forEach((f) => {
        let rowToCheck = value.tableDef.data.data[f]

        if (rowToCheck["Skl"] === skl) {
          if (rowToCheck["ItemCode"] !== itemCode) {
            changed = true
            rowToCheck["ItemCode"] = itemCode
            rowToCheck["ItemName"] = itemName
            rowToCheck["Price"] = undefined
          }
        }
      })
      if (changed) {
        state.app.features.QUTOffering.detailsChanged =
          state.app.features.QUTOffering.selectedOfferKey
        state.app.features.QUTOffering.detailsMaterialChanged = true
      }
    }
    return { resolve: "SaveLocally" }
  } else if (
    value.tableDef.def.id === "QUTOfferingTransport" &&
    value.hasChanges
  ) {
    let changedFields = value.changedFields
    let rowToSave: Transport = value.tableDef.data.data[value.key]
    Object.assign(rowToSave, changedFields)
    state.app.features.QUTOffering.detailsChanged =
      state.app.features.QUTOffering.selectedOfferKey
    state.app.features.QUTOffering.detailsTransportChanged = true
    return { resolve: "SaveLocally" }
  } else if (value.tableDef.def.id === "QUTOfferingCosts" && value.hasChanges) {
    state.app.features.QUTOffering.detailsChanged =
      state.app.features.QUTOffering.selectedOfferKey
    state.app.features.QUTOffering.detailsCostChanged = true
    return { resolve: "SaveLocally" }
  }
}

const HookFormInit: SYSAction<
  HookFormInit_Type,
  Promise<HookFormInit_ReturnType>
> = async ({ formState }, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let res: HookFormInit_ReturnType = { fieldsToRemove: [], groupsToRemove: [] }
  switch (formState.tableDefId) {
    case "QUTOfferingMaterial":
      if (
        formState.fields["ItemCode"].convertedValue.indexOf(
          state.app.global.GEN.user.offeringDummyMaterialItemCode
        ) > -1
      ) {
        await FieldSetVal(
          formState.fields["ItemCode"],
          T("QUTOfferingOfferingMaterialDescDummy")
        )
      }
      break
    case "QUTOfferingCosts":
      if (formState.row.ItemType === "MaterialTreatment") {
        // don't remove costcost because it gets resetted from withing formchanged
        // by setting it to inactive FieldSetVal still can be used but there will be no validation
        await FieldSetState(formState.fields.CostCost, false, {
          mode: "visible/notvisible",
        })
        //res.fieldsToRemove.push(formState.fields.CostCost.fieldKey)
        res.fieldsToRemove.push(formState.fields.CostDescription.fieldKey)
        formState.fields.Quantity.ui.labelTranslationKey = `${formState.row.CostDescription}Value`
      } else if (formState.row.ItemType === "ManualSurcharge") {
        formState.fields.CostDescription.ui.readonly = false
        res.fieldsToRemove.push(formState.fields.Quantity.fieldKey)
      }
  }
  return res
}

const HookTableDialogGetTitleRender: SYSAction<
  HookTableDialogGetTitleRender_Type,
  HookTableDialogGetTitleRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  if (value.tableDefId === "QUTOfferingCosts") {
    if (
      value.formState?.row?.ItemType == "MaterialTreatment" ||
      value.formState?.row?.ItemType == "ManualSurcharge"
    ) {
      return html`${T(value.formState.row.CostDescription)}`
    }
  } else if (value.tableDefId === "QUTOfferingMaterial") {
    return html`${T("QUTOfferingOfferingMaterialEditTitle")}`
  } else if (value.tableDefId === "QUTOfferingTransport") {
    return html`${T("QUTOfferingOfferingTransportEditTitle")}`
  }
}

const HookField_ItemCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  return state.app.features.QUTOffering.lookups.U_ItemCode
}

const HookField_TransportType_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let res: HookFieldGetList_ReturnType = {
    data: {
      Home: {
        TransportType: "Home",
        TransportTypeDescription: T(
          "QUTOfferingOfferingDetailsSelectTransportHome"
        ),
      },
      Zip: {
        TransportType: "Zip",
        TransportTypeDescription: T(
          "QUTOfferingOfferingDetailsSelectTransportZipCode"
        ),
      },
    },
    lookupDef: {
      TransportTypeDescription: {
        type: "text",
        translationKey: "QUTOfferingOfferingDetailsSelectTransportType",
      },
    },
  }
  return res
}

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let formState = value.formState

  if (
    formState.tableDefId === "QUTOfferingTransport" &&
    value.changedField.field.fieldKey === "TransportType"
  ) {
    let convertedValue = FieldVal(formState.fields["TransportType"])
    let res = convertedValue === "Zip"
    await FieldSetState(formState.fields["ZipCode"], res, {
      focusWhenVisible: true,
      selectIfFocusSet: true,
      animate: "none",
    })
    await FieldSetState(formState.fields["City"], res, { animate: "none" })
    await FieldSetState(formState.fields["Street"], res, { animate: "none" })
    await FieldSetState(formState.fields["ZipCodeC"], !res, {
      mode: "readonly/notvisible",
      animate: "none",
    })
    await FieldSetState(formState.fields["CityC"], !res, {
      mode: "readonly/notvisible",
      animate: "none",
    })
    await FieldSetState(formState.fields["StreetC"], !res, {
      mode: "readonly/notvisible",
      animate: "none",
    })
  } else if (formState.tableDefId === "QUTOfferingCosts") {
    if (
      value.changedField.validValueChanged &&
      value.changedField.field.fieldKey === "Quantity"
    ) {
      await FieldSetVal(value.formState.fields.CostCost, null)
    }
  }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  if (value.formState.tableDefId === "QUTOfferingTransport") {
    if (value.field.fieldKey === "ZipCode") {
      if (!isValidSwissPLZ(FieldCurrentVal(value.field))) {
        value.validationsAdd("QUTOfferingOfferingDetailsValidatorZipCode")
      }
    }
  } else if (value.formState.tableDefId === "QUTOfferingCosts") {
    if (
      value.field.fieldKey === "CostCost" ||
      value.field.fieldKey === "Quantity"
    ) {
      value.validatorUse("Mandatory")
    }
    if (value.field.fieldKey === "CostDescription") {
      value.validatorUse("Mandatory")
      value.validatorUse("MaxLength", { val: 200 })
    }
  }
}
const isValidSwissPLZ = (plz: string) => {
  if (!plz) {
    return false
  }
  let plzNum = parseInt(plz.replace("CH-", "").toString())
  if (isNaN(plzNum)) {
    return false
  }
  if (plzNum.toString().length !== 4) {
    return false
  }
  return true
}

const HookField_TransportCost_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let total = "---"
  if (
    !state.app.features.QUTOffering.detailsTransportChanged &&
    !state.app.features.QUTOffering.detailsMaterialChanged &&
    !state.app.features.QUTOffering.cutPositionsChanged
  ) {
    total = N(<number>value.row["TransportCost"])
  }
  return { res: total, useDefault: false }
}

const HookField_CostCost_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let total = "---"
  let val = value.row["CostCost"]

  if (
    value.row !== null &&
    (value.row.ItemType === "ManualSurcharge" ||
      value.row.ItemType === "MaterialTreatment" ||
      (!state.app.features.QUTOffering.detailsMaterialChanged &&
        !state.app.features.QUTOffering.cutPositionsChanged))
  ) {
    total = N(<number>val)
  }
  return { res: total }
}

const HookField_Price_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let total = "---"
  if (
    !state.app.features.QUTOffering.detailsMaterialChanged &&
    !state.app.features.QUTOffering.cutPositionsChanged
  ) {
    total = N(<number>value.row["Price"])
  }
  return { res: total, useDefault: false }
}

const HookField_LineTotal_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let total = "---"
  if (
    !state.app.features.QUTOffering.detailsMaterialChanged &&
    !state.app.features.QUTOffering.cutPositionsChanged
  ) {
    total = N(<number>value.row["LineTotal"])
  }
  return { res: total, useDefault: false }
}

const HookField_MaterialDescription_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  const handleClick = (e: Event, rowKey: any) => {
    e.preventDefault()
    e.stopPropagation()
    TableFormEditRow("QUTOfferingMaterial", rowKey)
  }
  let row = <Material>value.row
  let itemName = T(row.ItemName, undefined, "Key")
  let isDummyClass = ""
  if (
    row.ItemCode.indexOf(
      state.app.global.GEN.user.offeringDummyMaterialItemCode
    ) > -1
  ) {
    isDummyClass = "offeringmaterialisdummy"
  }
  if (EditLocked()) {
    return { res: itemName }
  }

  if (state.app.features.QUTOffering.offerMainType === "CUT") {
    return {
      // prettier-ignore
      res: html`<div><span> ${itemName} </span><br /><span class="offeringmaterialdimensions">${row.Width} * ${row.Height} * ${row.Length}</span></div>`,
    }
  }

  return {
    // prettier-ignore
    res: html`<div><span class=${`offeringmateriallink ${isDummyClass}`}><a href="" id=${`material${row.LineNum}`} @click=${(e) => handleClick(e, value.rowKey)}>${itemName}</a></span><br /><span class="offeringmaterialdimensions">${row.Width} * ${row.Height} * ${row.Length}</span></div>`,
    valueRaw: itemName,
  }
}

const HookField_CostDescription_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let row = <Costs>value.row
  const handleClick = (e: Event, rowKey: any) => {
    e.preventDefault()
    e.stopPropagation()
    TableFormEditRow("QUTOfferingCosts", rowKey)
  }
  if (
    EditLocked() ||
    !(
      row.ItemType === "MaterialTreatment" ||
      (FeatureInfo("QUTOfferingToolAdmin") &&
        row.ItemType === "ManualSurcharge")
    )
  ) {
    return { res: T(row.CostDescription, undefined, "Key") }
  }

  return {
    // prettier-ignore
    res: html`<div><span class="offeringcostlink"><a href="" id=${`material${row.Id}`} @click=${(e) => handleClick(e, value.rowKey)}>${T(row.CostDescription, undefined, "Key")}</a></span></div>`,
    valueRaw: row.CostDescription,
  }
}

const HookField_TransportDescription_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  const handleClick = (e: Event, rowKey: any) => {
    e.preventDefault()
    e.stopPropagation()
    TableFormEditRow("QUTOfferingTransport", rowKey)
  }

  let row = <Transport>value.row

  let desc
  if (row.TransportType === "Home") {
    desc = T("QUTOfferingOfferingDetailsTransportHome")
  } else {
    let deliveryText = `${row.Street ? `${row.Street},` : ""} ${row.ZipCode} ${
      row.City ? row.City : ""
    }`
    desc = T("QUTOfferingOfferingDetailsTransportZip", [deliveryText])
  }
  if (EditLocked()) {
    return { res: desc }
  }
  return {
    // prettier-ignore
    res: html`<div><span class="offeringtransportlink"><a href="" id="transportRow" @click=${(e) => handleClick(e, value.rowKey)}>${desc}</a></span></div>`,
    valueRaw: desc,
  }
}

const HookTableRowFnCan: SYSAction<HookTableRowFnCan_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()

  let set = value.set

  if (EditLocked()) {
    set("SYSEdit", { visibility: "NotVisible" })
  } else if (value.tableDef.id === "QUTOfferingCosts") {
    let row = value.tableData.data[value.rowKey]

    if (
      !(
        row.ItemType === "MaterialTreatment" ||
        (FeatureInfo("QUTOfferingToolAdmin") &&
          row.ItemType === "ManualSurcharge")
      )
    ) {
      set("SYSEdit", { visibility: "NotVisible" })
    }
  } else if (value.tableDef.id === "QUTOfferingMaterial") {
    if (state.app.features.QUTOffering.offerMainType === "CUT") {
      set("SYSEdit", { visibility: "NotVisible" })
    }
  }
}

export let hooks = {
  HookTableBeforeSave,
  HookFormInit,
  HookTableDialogGetTitleRender,
  HookField_ItemCode_GetList,
  HookField_TransportType_GetList,
  HookFormChanged,
  HookFormValidate,
  HookField_TransportCost_GetValueRender,
  HookField_CostCost_GetValueRender,
  HookField_Price_GetValueRender,
  HookField_LineTotal_GetValueRender,
  HookField_MaterialDescription_GetValueRender,
  HookField_CostDescription_GetValueRender,
  HookField_TransportDescription_GetValueRender,
  HookTableRowFnCan,
  HookTableSetColumnVisibility,
  /*HookTableInit,*/
}
